const CLEAR_EMAIL_CODES = new Set([
    'auth/invalid-action-code',
    'auth/expired-action-code',
    'auth/invalid-email',
    'auth/user-disabled',
    'auth/user-not-found',
]);

export const shouldClearStoredEmail = (error) =>
    !!error && CLEAR_EMAIL_CODES.has(error.code);

export const maskEmail = (email) =>
    (email || '').replace(/(.{3}).*(@.*)/, '$1***$2');

export const buildSentryRequestContext = ({ error, email, redirectUrl, feature }) => ({
    tags: {
        feature,
        errorCode: error?.code || 'unknown',
        upstreamStatus: error?.details?.upstreamStatus ?? 'none',
        opcRequestId: error?.details?.opcRequestId ?? 'none',
    },
    level: 'error',
    contexts: {
        request: {
            email: maskEmail(email),
            redirectUrl,
        },
        upstream: error?.details ?? null,
    },
});
